module.exports = __webpack_public_path__ + "static/Sedgwick-Ave-55c2c704487fd7fc21f0adc0e0452237.woff2";